import { SWRConfig } from 'swr';
import { useSnackbar } from 'notistack';

const SwrWrapper: React.FC = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();

  return (
    <SWRConfig value={{
      onError: (error: { message:string, config: { method:string, url:string }, response:{ status:number } }) => {
        if (error?.response?.status === 401) {
          enqueueSnackbar('Your session could not be verified. Retrying shortly — sign in again if this persists.', { variant: 'warning', preventDuplicate: true });
        } else if (error?.response?.status === 403) {
          enqueueSnackbar(`Insufficient access to make ${error.config.method} call to ${error.config.url} ${error.message}.`, { persist: false, variant: 'error', preventDuplicate: true });
        } else {
          enqueueSnackbar('Unknown error, check console for detailed error.', { persist: false, variant: 'error', preventDuplicate: true });
          console.log(`${error.config.method} to ${error.config.url} ${error.message}`);
        }
      },
      refreshWhenHidden: false,
    }}
    >
      {children}
    </SWRConfig>
  );
};

export default SwrWrapper;
